import en from "./en-us";
import zhcn from "./zh-cn";
import zhhk from "./zh-hk";

export default {
  "en-us": en,
  "zh-cn": zhcn,
  "zh-hk": zhhk,
};
